module.exports = __webpack_public_path__ + "img/finland-digestive-diseases-female.187cbbed.png";